const MIN_PAYMENT_IN_CENTS = 100
const MAX_PAYMENT_IN_CENTS = 1000 * 100

export const isPaymentBetweenLimits = payment =>
    MIN_PAYMENT_IN_CENTS <= payment && payment <= MAX_PAYMENT_IN_CENTS
